"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M7 16h14V7H7zm5-8 5.5 3.5L12 15z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M3 9H1v11c0 1.11.89 2 2 2h16v-2H3z"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M18 5V3c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H5v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5zm-6-2h4v2h-4zm9 13H7V7h14z"
}, "2"), /*#__PURE__*/_jsx("path", {
  d: "M12 8v7l5.5-3.5z"
}, "3")], 'Shop2TwoTone');